module.exports = __webpack_public_path__ + "static/media/reset-controls.bcad3cff.svg";